import { render } from "./FormLabel.vue?vue&type=template&id=1f743887"
import script from "./FormLabel.vue?vue&type=script&lang=js"
export * from "./FormLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/FormLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f743887"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f743887', __exports__)) {
    api.reload('1f743887', __exports__)
  }
  
  module.hot.accept("./FormLabel.vue?vue&type=template&id=1f743887", () => {
    api.rerender('1f743887', render)
  })

}


export default __exports__